<template>
  <div class="payment-button-wrapper">
    <div
      v-if="showRecaptchaButton"
      class="payment-button"
    >
      <vue-recaptcha
        id="recaptcha-button"
        :load-recaptcha-script="true"
        :sitekey="recaptchaKey"
        class="recaptcha"
        size="normal"
        @verify="verifyRecaptchaResponse"
        @expired="expiredRecaptchaResponse"
      >
        <b-btn
          :class="{ 'payment-disabled' : disableButton }"
          :disabled="disableButton"
          variant="primary"
          class="payment-button"
          @click="buttonClick"
        >
          <slot>
            Process payment
          </slot>
        </b-btn>
      </vue-recaptcha>
      <b-tooltip
        v-if="tooltipMessage"
        target="recaptcha-button"
        placement="bottom"
        triggers="hover"
      >
        {{ tooltipMessage }}
      </b-tooltip>
    </div>
    <div v-else>
      <div id="non-recaptcha-button">
        <b-btn
          :class="{ 'payment-disabled' : disableButton }"
          :disabled="disableButton"
          variant="primary"
          class="payment-button"
          @click="buttonClick"
        >
          <slot>
            Process payment
          </slot>
        </b-btn>
      </div>
      <b-tooltip
        v-if="tooltipMessage"
        target="non-recaptcha-button"
        placement="bottom"
        triggers="hover"
      >
        {{ tooltipMessage }}
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'card-payment-button',
  components: {
    'vue-recaptcha': VueRecaptcha
  },
  props: {
    label: {
      type: String,
      required: false,
      default: 'Process Payment'
    },
    formType: {
      type: String,
      required: false,
      default: 'Payment'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    tooltipMessage: {
      type: String,
      required: false,
      default: 'complete the form details'
    }
  },
  data: function() {
    return {
      recaptchaResponse: null
    }
  },
  computed: {
    paymentTesting: function() {
      return (this.$store.state.square.mode === 'development')
    },
    recaptcha: function() {
      try {
        if (this.$store.state.square.site_settings.recaptcha.key && this.$store.state.square.site_settings.recaptcha.forms[this.formType]) {
          return {
            key: this.$store.state.square.site_settings.recaptcha.key,
            mode: 'checkbox'
          }
        }
        else {
          return false
        }
      }
      catch (err) {
        return false
      }
    },
    disableButton: function() {
      return this.disabled || !this.recaptchaVerified
    },
    recaptchaKey: function() {
      return (this.recaptcha) ? this.recaptcha.key : null
    },
    recaptchaMode: function() {
      return ['invisible', 'checkbox'].includes(this.recaptcha.mode) ? this.recaptcha.mode : 'checkbox'
    },
    showRecaptchaButton: function() {
      return (typeof this.recaptchaKey === 'string' && this.recaptchaKey.length > 0)
    },
    recaptchaVerified: function() {
      if (this.showRecaptchaButton) {
        return this.recaptchaResponse !== null
      }
      else {
        return true
      }
    }
  },
  methods: {
    verifyRecaptchaResponse: function(response) {
      this.$emit('recaptchaVerified', true)
      this.recaptchaResponse = response
    },
    expiredRecaptchaResponse: function() {
      this.$emit('recaptchaVerified', false)
      this.recaptchaResponse = null
    },
    processPayment: function() {
      if (this.recaptchaVerified) {
        this.$emit('click', this.recaptchaResponse)
      }
    },
    buttonClick: function() {
      if (this.recaptchaVerified) {
        this.processPayment()
      }
    }
  }

}
</script>

<style scoped lang="scss">
  .payment-button-wrapper, .payment-button {
    width:100%;
    margin:1rem auto auto auto;
    padding:1em;
  }

  ::v-deep #recaptcha-button > div > div {
    width: 100% !important;
    text-align: right;
  }
</style>
